import { CheckCircleIcon, XCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--color-gray-900)',
          '--normal-text': 'var(--color-white)',
          '--border-radius': '16px',
          '--normal-border': 'transparent',
        } as React.CSSProperties
      }
      {...props}
      toastOptions={{}}
      icons={{
        error: <XCircleIcon size={32} className="text-red-450" weight="fill" />,
        success: (
          <CheckCircleIcon
            size={32}
            className="text-outline-primary"
            weight="fill"
          />
        ),
      }}
    />
  )
}

export { Toaster }
